module.exports = __webpack_public_path__ + "static/media/logout.9cc7e3c0.svg";